export const SWAP_DEADLINE_MINUTES = 20;
export const TRADING_FEE_H2 = 0.003;
export const AGENTFUN_TAX = 0.01;
export const LAUNCH_TOKEN_FEE_AGENTFUN = 1;
export const NATIVE_TOKEN_IDENTIFIER = 'NATIVE';
export const L2_BASE_TOKEN_ADDRESS = '0x000000000000000000000000000000000000800a'; // same constant in zksync-ethers
export const ZKCRO_DECIMALS = 18;
export const FUN_TOKEN_DECIMALS = 18;
export const BONDING_TOKEN_DECIMALS = 18;
export const AGENT_TOKEN_DECIMALS = 18;
// constants taken from H2 code
export const BASE_SWAP_COST_V2 = 135000;
export const COST_PER_EXTRA_HOP_V2 = 50000;
export const COST_PER_INIT_TICK = 31000;
// bonding curve constants
export const BONDING_K = 3000000000000n;
export const BONDING_SUPPLY = 1000000000n * 10n ** BigInt(FUN_TOKEN_DECIMALS);
